import * as React from 'react';
type Props = {
  className?: string;
};
export function Cart({ className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      data-testid="utility-cart"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0226 19.3946C12.0226 20.2068 11.3644 20.865 10.5522 20.865C9.73999 20.865 9.08177 20.2068 9.08177 19.3946C9.08177 18.5823 9.73999 17.9241 10.5522 17.9241C11.3644 17.9241 12.0226 18.5823 12.0226 19.3946Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9044 19.3946C17.9044 20.2068 17.2462 20.865 16.434 20.865C15.6218 20.865 14.9635 20.2068 14.9635 19.3946C14.9635 18.5823 15.6218 17.9241 16.434 17.9241C17.2462 17.9241 17.9044 18.5823 17.9044 19.3946Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.46694 5.47622L4.87909 5.1624L5.34219 6.35325L7.882 13.2878L8.18333 15.2967C8.33018 16.2757 9.17121 17 10.1612 17H17.5V15H10.1612L9.97371 13.75H17.6499L20.7576 6.75772C21.125 5.93111 20.5199 5.00004 19.6153 5.00004H6.96186L6.68088 4.27753C6.35877 3.44924 5.48036 2.98 4.6128 3.17279L3.03308 3.52384L3.46694 5.47622ZM9.44872 11.75L7.70901 7.00004H18.4613L16.3501 11.75H9.44872Z"
        fill="currentColor"
      />
    </svg>
  );
}
